exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".range-slider {\n  padding: 0;\n  width: 100%;\n}\n.range-slider .range-slider-rail,\n.range-slider .range-slider-fill {\n  height: 20px;\n  border-radius: 10px;\n}\n.range-slider .range-slider-knob {\n  width: 35px;\n  height: 35px;\n  box-shadow: 1px 1px rgba(0, 0, 0, 0.3);\n}\n.range-slider .range-slider-fill {\n  background-color: #a05dcd;\n}\n.range-slider.\\--danger .range-slider-fill {\n  background-color: #ff857a;\n}\n.range-slider.\\--success .range-slider-fill {\n  background-color: #9ccc65;\n}\n", ""]);

// exports
